// CardGrid.tsx — Phase 11 Step 3 Block 5
// 4-Spalten-Grid für ScrollyCards.
// Source-of-truth: Scrolly Platform.html:1032–1040.
//
// TODO(Block 3-Notiz): Falls die Cards im Feed visuell "kleben", Gap hochziehen
// (Container-Space), nicht `CARD_STYLES.cardPadding` (Inner-Space). Default 20
// ist quell-treu.

import type { ReactNode } from "react";

export type CardGridProps = {
  children: ReactNode;
  cols?: number;
  gap?: number;
};

export function CardGrid({ children, cols = 4, gap = 20 }: CardGridProps) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap,
      }}
    >
      {children}
    </div>
  );
}
